
import './App.css';
import React, {useState, useEffect} from "react"
import nonStarchyVeggies from "./utils/Data"
import veggies from "./utils/Data"
import Select from "react-select"
function App() {
  const [allFoods, setAllFoods] = useState([])
  const [next, setNext] = useState(false)
  const [nonStarchy, setNonStarchy] = useState("Yes")
  const [veggieState, setVeggieState] = useState([])
  const [veggieQuantity, setVeggieQuantity] = useState("")
  const [nonStarchyList, setNonStarchyList] = useState([])
  const [food, setFood] = useState("")
  const [currentVeggie, setCurrentVeggie] = useState({})
  const [foodQuantity, setFoodQuantity] = useState("")
  const [displayTotals, setDisplayTotals] = useState(false)
  const [calories, setCalories] = useState("")
  const [protein, setProtein] = useState("")
  const [carbs, setCarbs] = useState("")
  const [totalVeggies, setTotalVeggies] = useState(0)
  const [fewerCarbs, setFewerCarbs] = useState(false)
  const [moreCarbs, setMoreCarbs] = useState(false)
  const [moreProtein, setMoreProtein] = useState(false)
  const [fewerProtein, setFewerProtein] = useState(false)
  const [balanced, setBalanced] = useState(false)
  
  const isBalanced = (veggieQuantity, carbs, protein)=> {
    const percentCarbs = carbs / veggieQuantity
    const percentProtein = protein / veggieQuantity
    if ((percentCarbs <= 0.6 && percentCarbs >= 0.4) && (percentProtein <= 0.6 && percentProtein >= 0.4)) {
      setBalanced(true)
    } 
    let results = "This isn't a balanced meal, here are some suggestions: "
    if (percentCarbs > 0.6) {
      setFewerCarbs(true)
    } else if (percentCarbs < 0.4) {
      setMoreCarbs(true)
    }
    if (percentProtein > 0.6) {
      setFewerProtein(true)
    } else if (percentProtein < 0.4) {
      setMoreProtein(true)
    }
    return results
  }
  const searchFoods = (e)=>{
    e.preventDefault()
    if (food.length === 0){
      alert("Please enter a food first.")
      return
    }
    fetch(`https://api.edamam.com/api/food-database/v2/parser?ingr=${food}&app_id=${process.env.REACT_APP_API_ID}&app_key=${process.env.REACT_APP_API_Key}`)
    .then((response)=>response.json())
    .then((data)=>{
      const foodData = data.hints[0].food.nutrients
      console.log(data.hints[0])
      const newFood = {
        name: food,
        protein: foodData.PROCNT,
        carbs: foodData.CHOCDF,
        calories: foodData.ENERC_KCAL,
        quantity: convertQuantities(foodQuantity)
      }
      console.log(newFood)
      const currentFoods = allFoods
      currentFoods.push(newFood)
      setAllFoods(currentFoods)
      setFood("")
      setFoodQuantity("")
    })
  }

  const handleSelectChange = (e)=> {
    if (e.target.name === "veggieQuantity") {
      setVeggieQuantity(e.target.value) 
    } else {
      setFoodQuantity(e.target.value)
    }
  }

  // const handleInputChange = (e)=> {
  //   setCurrentVeggie(e.target.value)
  //   if (e.target.value.length > 0){
  //     const matches = findMatches(e.target.value, nonStarchyVeggies)
  //   setNonStarchyList(matches)
  //   } else {
  //     setNonStarchyList([])
  //   }
    
  // }

  const findMatches = (foodToMatch, list)=> {
    return list.filter(food=> {
      // const regex = new RegExp(foodToMatch, "gi")
      // return food.name.match(regex)
    return foodToMatch[0].toLowerCase() === food.name[0].toLowerCase()
    })
  }

  const addVeggie = (e)=> {
    e.preventDefault()
    if (!currentVeggie.value){
      alert("Please select a vegetable first.")
      return
    }
    trackTotalVeggies(veggieQuantity)
    const newVeggie = currentVeggie
    newVeggie.quantity = convertQuantities(veggieQuantity)
    const currentVeggies = nonStarchyList
    currentVeggies.push(newVeggie)
    setNonStarchyList(currentVeggies)
    const currentFoods = allFoods
    currentFoods.push(newVeggie)
    setAllFoods(currentFoods)
    setCurrentVeggie({})
  }
  const trackTotalVeggies = (quantity)=> {
    const newQuantity = convertQuantities(quantity)
    let currentTotal = totalVeggies
    currentTotal += newQuantity
    setTotalVeggies(currentTotal)
  }
  const calculateTotals = (e)=> {
    e.preventDefault()
    const calories = allFoods.reduce((total, food)=>{
      return total + (food.calories * food.quantity)
    }, 0)
    const carbs = allFoods.reduce((total, food)=>{
      return total + (food.carbs * food.quantity)
    }, 0)
    const protein = allFoods.reduce((total, food)=>{
      return total + (food.protein * food.quantity)
    }, 0)
    setCarbs(carbs.toFixed(2))
    setCalories(calories.toFixed(2))
    setProtein(protein.toFixed(2))
    console.log("allFoods: ", allFoods)
    isBalanced(totalVeggies, carbs, protein)
    setDisplayTotals(true)
  }
  const convertQuantities = (quantity)=> {
    if (quantity === "1/4 serving" || quantity === "1/4 cup"){
      return 0.25
    } else if (quantity === "1/2 serving" || quantity === "1/2 cup"){
      return 0.5
    } else if (quantity === "1 serving" || quantity === "1 cup"){
      return 1
    } else if (quantity === "1 1/2 servings" || quantity === "1 1/2 cups"){
      return 1.5
    } else {
      return 2
    }
  }
  const getVeggieData = (veg)=> {
    veg = veg.toLowerCase()
    const foundVeg = veggies.find((item)=> item.name.toLowerCase() === veg)
    return foundVeg
  }
  const handleVeggieSelect = (currentVeggie)=> {
    setCurrentVeggie(currentVeggie)
  }
  return (
    <div className="App">
      <h1>Balanced Meal Calculator</h1>
      <form className="food-label">
        Did you eat non-starchy vegetables?
        <label>
          <input type="radio" value = "Yes" name = "vegetables" checked = {nonStarchy === "Yes"} onChange = {(e)=>setNonStarchy(e.target.value)}/> 
          Yes 
        </label>
        <label>
          <input type="radio" value = "No" name = "vegetables" checked = {nonStarchy === "No"} onChange = {(e)=>setNonStarchy(e.target.value)}/> 
          No
        </label>
      </form>
      {nonStarchy === "Yes" ? (
        <>
        <form onSubmit = {addVeggie}>
        {/* <input type="text" value = {currentVeggie} onChange = {handleInputChange} placeholder = "Input vegetables"/> */}
        <Select options = {veggies} value = {currentVeggie} onChange = {handleVeggieSelect}/>
        {nonStarchyList.map(item=>(
          <p>
            {item.name}
          </p>
        ))}
        <select name = "veggieQuantity" value = {veggieQuantity} onChange = {handleSelectChange}>
          <option value = "Select quantity"> Select quantity </option>
          <option value = "1/4 cup"> 1/4 cup </option>
          <option value = "1/2 cup"> 1/2 cup </option>
          <option value = "1 cup"> 1 cup </option>
          <option value = "1 1/2 cups"> 1 1/2 cups </option>
          <option value = "2 cups"> 2 cups </option>
        </select>
        <input type = "submit" value = "Add Vegetable" />
      </form>
      <button onClick = {()=>setNext(true)}>
        Next
      </button>
      {
        next && ( 
        <form>
        <div className = "add-food-form">
        <input type="text" value = {food} name = "food" onChange = {(e)=>setFood(e.target.value)} placeholder = "What else did you eat?"/>
        <select name = "foodQuantity" value = {foodQuantity} onChange = {handleSelectChange}>
        <option value = "Select quantity"> Select quantity </option>
           <option value = "1/4 serving"> 1/4 serving </option>
           <option value = "1/2 serving"> 1/2 serving </option>
           <option value = "1 serving"> 1 serving </option>
           <option value = "1 1/2 servings"> 1 1/2 servings </option>
           <option value = "2 servings"> 2 servings </option>
         </select> 
         </div>
         <button onClick={searchFoods}> Add Food </button> 
         </form>
        )
      }
      </> 
      ) :(
        <>
        <input type="text" value = {food} name = "food" onChange = {(e)=>setFood(e.target.value)} placeholder = "What did you eat?"/>
        <select name = "foodQuantity" value = {foodQuantity} onChange = {handleSelectChange}>
        <option value = "Select quantity"> Select quantity </option>
           <option value = "1/4 serving"> 1/4 serving </option>
           <option value = "1/2 serving"> 1/2 serving </option>
           <option value = "1 serving"> 1 serving </option>
           <option value = "1 1/2 servings"> 1 1/2 servings </option>
           <option value = "2 servings"> 2 servings </option>
         </select> 
         <button onClick={searchFoods}> Add Food </button> 
         </>
      )} 
      <button onClick={calculateTotals}>
        Calculate
      </button>
      {
        displayTotals && (
          <div className = "totals">
          <p>
            Total calories: {calories}
          </p>
          <p>
            Total grams of carbohydrates: {carbs}
          </p>
          <p>
            Total grams of protein: {protein}
          </p>
          {balanced ? (
            <p>
              <strong>
                This is a balanced meal!
              </strong>
            </p>
          ) : (
            <>
            <p>
              <strong>
                This isn't a balanced meal, here are some suggestions:
              </strong>
            </p>
            {nonStarchyList.length === 0 ? <p>Eat more non-starchy vegetables</p> :(
              <>
              {fewerCarbs && <p>Eat fewer carbohydrates</p>}
              {moreCarbs && <p>Eat more carbohydrates</p>}
              {fewerProtein && <p>Eat less protein</p>}
              {moreProtein && <p>Eat more protein</p>}
              </>
            )} 
            </>
          )}
          </div>
        )
      }
    </div>
  );
}

export default App;
